import * as React from 'react';
import cx from 'classnames';

type MobileFilterButtonProps = {
  label?: string;
  color?: string;
};

const MobileFilterButton: React.FC<
  MobileFilterButtonProps &
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >
> = ({ label, children, className, color, ...props }) => {
  return (
    <label
      className={cx('mobile-filter-btn-container', className && className)}
    >
      <input type="checkbox" {...props} />

      <span className="mobile-filter-btn">
        <div
          className={cx('mobile-filter-btn-box')}
          style={{ backgroundColor: color ?? 'white' }}
        >
          {label ?? children}
        </div>
      </span>
    </label>
  );
};

export default MobileFilterButton;
